import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full justify-between" }
const _hoisted_2 = { class: "flex grow flex-col items-center justify-center px-[34px]" }
const _hoisted_3 = { class: "flex flex-col w-full px-[34px] align-center mb-8" }
const _hoisted_4 = { class: "flex w-full items-center justify-between" }

import router from '@/router';
import { IonButton, IonContent, IonIcon, IonInput } from '@ionic/vue';
import TopBar from '@/shared/components/TopBar.vue';
import { arrowForwardOutline, qrCodeOutline } from 'ionicons/icons';
import TextInput from '@/shared/components/sign-up-forms/TextInput.vue';
import BackButton from '@/shared/components/BackButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VouchersShareEmailPage',
  setup(__props) {

const goTo = async (link: string) => {
	await router.push({ path: link, query: { callbackPage: 'dashboard' } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TopBar, { class: "px-[34px]" }, {
          left: _withCtx(() => [
            _createVNode(BackButton)
          ]),
          center: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "flex grow justify-center w-full font-sourcesanspro-semibold text-l2" }, "Share with friends", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TextInput, {
            "wrapper-class": "flex flex-wrap justify-left item-center mb-2 border border-solid focus-within:background-white-15",
            name: "email",
            type: "email",
            placeholder: "Email"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-sourcesanspro-regular text-sm2 text-white/50" }, "Enter your friend's email.", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(IonButton), {
            class: "w-full",
            expand: "full",
            size: "large",
            shape: "round",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('/vouchers/success')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[3] || (_cache[3] = _createTextVNode(" Continue ", -1)),
                _createVNode(_unref(IonIcon), {
                  icon: _unref(arrowForwardOutline),
                  class: "text-dark-blue mr-2"
                }, null, 8, ["icon"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})